import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { Route } from '../../graphql/schema/types/route'

export interface RouteQueryProps {
  readonly id: string
  readonly children: (rowData: Route) => React.ReactElement
}

export const routeQuery = gql`
  query route($id: ID!) {
    route(id: $id) {
      ...Route
    }
  }

  fragment Route on Route {
    id
    hash
    signature
    discovered
    environments
    exercised
    servers {
      id
      name
      environment
      agentVersion
      enabled
    }
    serversTotal
    vulnerabilityCount
    criticalVulnerabilityCount
    status
    app {
      id
      name
    }
  }
`

export function RouteQuery({ id, children }: RouteQueryProps) {
  return (
    <Query
      query={routeQuery}
      errorPolicy="all"
      fetchPolicy="cache-only"
      variables={{ id }}
    >
      {({ data, ...props }) => {
        if (props.error) {
          throw Error(props.error)
        }
        return children(data.route)
      }}
    </Query>
  )
}
